export default __webpack_public_path__ + "static/media/bandMember-Tom.20dadd57.jpg";